import { render, staticRenderFns } from "./Datatables.vue?vue&type=template&id=8876173c&scoped=true&"
import script from "./Datatables.vue?vue&type=script&lang=js&"
export * from "./Datatables.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8876173c",
  null
  
)

export default component.exports